import React from "react";

import "./Projects.css";
import Btn from "../../Components/Btn/Btn";
import { Link } from "react-router-dom";

// Helper to generate Cloudinary srcset (can be moved to a utils file)
const getCloudinarySrcset = (
  imageUrl,
  baseParams = "f_auto,q_auto:good,dpr_auto"
) => {
  const widths = [200, 300, 400, 500, 600]; // Adjusted widths for potentially smaller cards
  return widths
    .map(
      (width) =>
        `${imageUrl.replace(
          "/upload/",
          `/upload/${baseParams},w_${width}/`
        )} ${width}w`
    )
    .join(", ");
};

// Define image data with their original URLs
const projectImagesData = [
  {
    id: "website1",
    alt: "website1",
    src: "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1740785175/yrdfinal/assets/templates/Homepage_1_aqknhu.jpg",
  },
  {
    id: "website2",
    alt: "website2",
    src: "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1740785249/yrdfinal/assets/templates/Website_Landing_Page_1_g4ncxh.jpg",
  },
  {
    id: "website3",
    alt: "website3",
    src: "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1740560195/yrdfinal/assets/templates/Photograph_-_Desktop_wxrqxu.jpg",
  },
  {
    id: "website4",
    alt: "website4",
    src: "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1740785158/yrdfinal/assets/templates/Portofoliu_-_Desktop_bvxl6a.jpg",
  },
];

const Projects = () => {
  // Define sizes attribute based on .projects .cards .card CSS
  // Assuming the container for .cards is roughly 90vw or similar, and 1rem gap.
  // On desktop (4 columns): (viewport_width * 0.9 / 4) - gap
  // On mobile (1 column): viewport_width * 0.9 - gap
  // This needs to be approximated or calculated more precisely if possible.
  // For now, a simplified version based on typical viewport percentage occupation:
  const imageSizesProjects = "(max-width: 830px) 85vw, 22vw";
  // 85vw for mobile (1 column, considering padding/margins)
  // 22vw for desktop (4 columns, ~1/4 of viewport, considering padding/margins/gaps)

  return (
    <section className="projects" id="projects">
      <div className="sub-title">
        <h2 className="text-2">
          Website-ul dorit <br />
          <span className="highlight">de la 1500€</span>
        </h2>
        {/* <p className="p-1">
          Descoperă cum putem aduce inovație în afacerea ta prin inteligență
          artificială, automatizare și strategii care generează rezultate rapide
          și eficiente.
        </p> */}
      </div>
      <div className="cards">
        {projectImagesData.map((imgData) => {
          const srcset = getCloudinarySrcset(imgData.src);
          const baseCloudinaryUrl = imgData.src.replace(
            "/upload/",
            "/upload/f_auto,q_auto:good,dpr_auto/"
          );
          return (
            <div className="card" key={imgData.id}>
              <img
                loading="lazy"
                src={baseCloudinaryUrl}
                srcSet={srcset}
                sizes={imageSizesProjects}
                alt={imgData.alt}
              />
            </div>
          );
        })}
      </div>
      <Link to={"/portofoliu"}>
        <Btn variant={"accent"}>Alege un Website</Btn>
      </Link>
    </section>
  );
};

export default Projects;
